<template>
    <section class="page8">
        <div class="conteudo text-left">
            <img
                class="persona"
                src="~@/assets/img/page7-persona.png"
                alt=""
                data-aos="fade-up"
            />
            <div class="col1 openSans">
                <div class="txt-col1 text-white">
                    <p
                        class="text-bold text-bigger"
                        data-aos="fade-down"
                        data-aos-delay="500"
                    >
                        Mas, afinal, que dados são esses?
                    </p>
                    <p class="p2" data-aos="fade-right" data-aos-delay="500">
                        <i
                            >Clique na lâmpada para <br />
                            saber.</i
                        >
                    </p>
                </div>
            </div>
            <div class="col2">
                <div
                    class="lamp"
                    v-if="isEnabled == false"
                    :class="{ enabled: isEnabled }"
                    v-on:click="lampClick()"
                >
                    <img src="~@/assets/img/page7-img1.png" alt="" />
                </div>
                <div
                    class="lamp"
                    v-if="isEnabled == true"
                    :class="{ enabled: isEnabled }"
                >
                    <img src="~@/assets/img/page7-img2.png" alt="" rel="preload" />
                </div>
                <transition name="fade">
                    <div
                        v-if="isEnabled == true"
                        class="txt-col2 text-white text-center text-big"
                    >
                        <p>
                            São os dados
                            <span class="text-bold">pessoais</span> e os dados
                            <span class="text-bold">sensíveis</span>. Vamos
                            conhecê-los no detalhe a seguir.
                        </p>
                    </div>
                </transition>
            </div>
        </div>
        <div class="conteudoMobile text-left">
            <div class="col1 openSans"></div>
            <div class="col2" :class="{ col2Enabled: isEnabled }">
                <div class="txt-col1 text-white">
                    <p class="text-bold text-bigger">
                        Mas, afinal, que dados são esses?
                    </p>
                    <p class="p2" v-if="!isEnabled">
                        <i
                            >Clique na lâmpada para <br />
                            saber.</i
                        >
                    </p>
                </div>
                <div
                    class="lamp"
                    v-if="isEnabled == false"
                    :class="{ enabled: isEnabled }"
                    v-on:click="lampClick()"
                >
                    <img src="~@/assets/img/page7-img1.png" alt="" />
                </div>
                <div
                    class="lamp"
                    v-if="isEnabled == true"
                    :class="{ enabled: isEnabled }"
                >
                    <img src="~@/assets/img/page7-img2.png" alt="" />
                </div>
                <transition name="fade">
                    <div
                        v-if="isEnabled == true"
                        class="txt-col2 text-white text-center text-big"
                    >
                        <p>
                            São os dados
                            <span class="text-bold">pessoais</span> e os dados
                            <span class="text-bold">sensíveis</span>. Vamos
                            conhecê-los no detalhe a seguir.
                        </p>
                    </div>
                </transition>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            isEnabled: false,
        };
    },
    methods: {
        lampClick() {
            this.isEnabled = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.page8 {
    position: relative;
    background-image: url("~@/assets/img/page7-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 640px;

    .conteudoMobile {
        display: none;
    }
    .enabled {
        pointer-events: none;
    }
    .persona {
        position: absolute;
        bottom: 0;
        left: -55px;
    }
    .lamp {
        cursor: pointer;
        position: absolute;
        top: 0;
    }
    .conteudo {
        position: relative;
        justify-content: space-evenly;
        height: 768px;
        align-items: flex-start;
    }

    .col1 {
        display: flex;
        justify-content: flex-end;
        width: 556px;
        padding-right: 20px;
        padding-left: 50px;
    }
    .col2 {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 556px;
    }
    .txt-col1 {
        padding-top: 100px;
        max-width: 265px;
        align-self: flex-end;
    }
    .txt-col2 {
        padding-bottom: 100px;
        max-width: 260px;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active em versões anteriores a 2.1.8 */ {
        opacity: 0;
    }
    @media (max-width: 1250px) {
        padding-left: 20px;
        padding-right: 20px;
        .lamp {
            height: 620px;
            img {
                max-width: 100%;
            }
        }
        .conteudo {
            display: none;
        }
        .persona {
            display: none;
        }
        .conteudoMobile {
            display: flex;
            height: 100%;
        }
        .txt-col1 {
            padding-top: 0;
            padding-bottom: 40px;
            max-width: 256px;
            align-self: center;
            text-align: center;
        }
        .col1 {
            display: none;
        }
        .col2 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
        }
        .col2Enabled {
            justify-content: flex-end;
        }
    }
}
</style> 